// src/middleware/authMiddleware.js
const authMiddleware = (navigate) => {
    const isAuthenticated = sessionStorage.getItem('userID');
    if (!isAuthenticated) {
        navigate('/login');
    }
};

export default authMiddleware;
